/**
 * VenueBookingStatusService
 * Service for VenueBookingStatus entity operations
 * Route: api/venuebookingstatuses
 * Controller: VenueBookingStatusesController.cs
 */
import { CrudService } from '../base/CrudService';
/**
 * VenueBookingStatusService
 * Handles venue booking status CRUD operations
 * Maps to /api/venuebookingstatuses endpoint
 */
export class VenueBookingStatusService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? VenueBookingStatusService.DEFAULT_SERVICE_PATH,
            basePath: VenueBookingStatusService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
VenueBookingStatusService.DEFAULT_SERVICE_PATH = 'meetings';
VenueBookingStatusService.BASE_PATH = 'api/venuebookingstatuses';
//# sourceMappingURL=VenueBookingStatusService.js.map